import type { ButtonProps } from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'iconoir-react';
import { browseColors } from './browse-tokens';

/**
 * Single source for the "New program" CTA on the browse page (filter bar and
 * empty state). Placement concerns (ml/mt) stay at the call site via props.
 */
const NewProgramButton = (props: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="plain"
      h="40px"
      px="16px"
      minW="auto"
      gap="8px"
      borderRadius="10px"
      fontSize="13.5px"
      fontWeight={600}
      bg={browseColors.primaryBg}
      color={browseColors.primaryText}
      _hover={{ bg: browseColors.primaryHoverBg }}
      {...props}
    >
      <Plus width={16} height={16} />
      {t('programs.newProgram')}
    </Button>
  );
};

export default NewProgramButton;
